import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useToast } from '../components/ui/use-toast';
import { useEffect } from 'react';

const SuperAdminGuard = ({ children }) => {
  const { admin } = useSelector((state) => state.auth);
  const { toast } = useToast();

  useEffect(() => {
    if (admin && admin.role !== 'SUPER_ADMIN') {
      toast({
        variant: "destructive",
        title: "Access Denied",
        description: "You do not have permission to access this section"
      });
    }
  }, [admin, toast]);

  if (!admin || admin.role !== 'SUPER_ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default SuperAdminGuard;